import { render, staticRenderFns } from "./ContactRepeatableInput.vue?vue&type=template&id=8dde40fe&scoped=true"
import script from "./ContactRepeatableInput.vue?vue&type=script&lang=ts"
export * from "./ContactRepeatableInput.vue?vue&type=script&lang=ts"
import style0 from "./ContactRepeatableInput.vue?vue&type=style&index=0&id=8dde40fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde40fe",
  null
  
)

export default component.exports